import TeaserSlider from './TeaserSlider';
import { MEDIA_QUERIES } from '../../../javascripts/constants';

const mql = window.matchMedia(MEDIA_QUERIES.xxl);
let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(
    (component) => component.deconstructor && component.deconstructor()
  );
  componentStore = [];

  const config = {
    showDots: true,
    scrollContainerClass: '.teaser-slider__inner',
    itemsContainerClass: '.teaser-slider__teasers',
    itemClass: '.teaser-slider__teaser',
    itemsToScroll: 1,
    itemsVisible: 1,
    resizeVerticalImages: false,
    positionControlsOnImages: false,
  };
  document.querySelectorAll('.teaser-slider').forEach(($slider) => {
    componentStore.push(new TeaserSlider($slider, mq, config));
  });
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
